import {OutwardInitValues, OutwardModel} from '../../outward/models/OutwardModel'

interface InwardItem {
  _id: string
  product: string
  name: string
  UOM: string
  quantity: number | string
  assetNumber: number | string
  remarks: string
}

export interface InwardModel {
  _id: string
  createdAt?: string
  approvedAt?: string
  approvedBy?: string
  rejectedBy?: string
  rejectedAt?: string
  rejectionReason?: string
  number: string
  outward: string
  providedToEmployee: string
  providedToDepartment: string
  location: string
  providedToEmployeeName: string
  providedToDepartmentName: string
  locationName: string
  items: [InwardItem]
}

export const InwardInitValues: InwardModel = {
  _id: '',
  createdAt: '',
  approvedAt: '',
  approvedBy: '',
  rejectedBy: '',
  rejectedAt: '',
  rejectionReason: '',
  number: '',
  outward: '',
  providedToEmployee: '',
  providedToDepartment: '',
  location: '',
  providedToEmployeeName: '',
  providedToDepartmentName: '',
  locationName: '',
  items: [
    {
      _id: '',
      product: '',
      name: '',
      UOM: '',
      quantity: '',
      assetNumber: '',
      remarks: '',
    },
  ],
}

export interface InwardSearchModel {
  number: string
  status: string
  createdAt: any
  approvedBy: string
  approvedAt: any
}
export const InwardSearchModelInitValues: InwardSearchModel = {
  number: '',
  status: '',
  createdAt: [],
  approvedBy: '',
  approvedAt: [],
}

export interface InwardTableModel {
  page: number
  sortBy: string
  sortOrder: string
  search: InwardSearchModel
}

export const InwardTableModelInitValues: InwardTableModel = {
  page: 1,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  search: InwardSearchModelInitValues,
}
